<template>
   <div class="user-info">
      <div class="title-content">
        <div class="title">个人信息</div>
      </div>
     <div class="edit-content">
       <div class="input-content">
         <div class="input-item d-flex align-items-center " v-if="infos.verify_status==2">
           <div class="label">
             审核不通过：
           </div>
           <div class="input" style="color:#f00">
             {{infos.verify_message}}
           </div>
         </div>
          <div class="input-item d-flex align-items-center ">
             <div class="label">
               供应商类型：
             </div>
             <div class="input">
              {{provider_name}}
             </div>
          </div>
<!--         <div class="input-item d-flex align-items-center " v-if="infos.provider_type!=2">-->
<!--           <div class="label">-->
<!--             项目编号：-->
<!--           </div>-->
<!--           <div class="input">-->
<!--             {{company_name}}-->
<!--           </div>-->
<!--         </div>-->
         <div class="input-item d-flex align-items-center " v-if="infos.provider_type!=2">
           <div class="label">
             单位名称：
           </div>
           <div class="input">
             {{infos.department_name}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center " v-if="infos.provider_type==1">
           <div class="label">
             法人姓名：
           </div>
           <div class="input">
             {{infos.legal_person}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             联系人：
           </div>
           <div class="input">
               {{infos.nickname}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             联系人手机号：
           </div>
           <div class="input">
             {{infos.mobile}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             证件类型：
           </div>
           <div class="input">
             {{identify_name}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             证件号码：
           </div>
           <div class="input">
             {{infos.identify_number}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             {{infos.provider_type==2?'居住地址':'公司所在区域'}}：
           </div>
           <div class="input">
             {{infos.province_name+infos.city_name+infos.district_name}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             {{infos.provider_type==2?'居住详细地址':'公司详细地址'}}：
           </div>
           <div class="input">
             {{infos.address}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             固定电话：
           </div>
           <div class="input">
             {{infos.phone}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             电子邮箱：
           </div>
           <div class="input">
             {{infos.email}}
           </div>
         </div>
         <div class="input-item d-flex align-items-center ">
           <div class="label">
             {{infos.provider_type==2?'身份证照':'营业执照'}}：
           </div>
           <div class="input imgInput" v-if="infos.provider_type==2">
<!--             <img :src="infos.identity_img.front_img" alt="" style="margin-right: 10px">-->
<!--             <img :src="infos.identity_img.back_img" alt="" style="margin-right: 10px">-->
             <img v-if="infos.identity_img&&infos.identity_img.sign_img" :src="infos.identity_img.sign_img" alt="">
           </div>
           <div class="input imgInput" v-else>
             <img :src="infos.license_img" alt="">
           </div>
         </div>
       </div>
       <div class="main-button">
         <div  @click="navTo('/editInfo')">编辑</div>
       </div>
     </div>
   </div>
</template>

<script>
export default {
  name: "userInfo",
  data(){
    return{
      infos:{},
      path:'',
      dialogImageUrl: '',
      dialogVisible: false,
      text:'',
      imgs:[],
      disable:false,
      identify_name:'',
      provider_name:'',
      province_name:'',
      city_name:'',
      district_name:'',
      company_name:''
    }
  },
  mounted(){
    this.getUserInfo()
  },
  methods:{
    getUserInfo(){
      this.$post('/api/user/index',{}).then(res => {
        this.setUserInfos(res.data)
        this.infos=res.data;

        if (res.data.verify_status==2){
          this.getIndexInfo()
        }else{
          this.getBaseInfo()
          //this.getProvince()
          this.getCompanyList(res.data)
        }

      });
    },
    getCompanyList(info){
      this.$post('/api/index/company_list', {}).then(res => {
        let list=res.data;
        if (info.company_id){
          for (let i=0;i<list.length;i++){
            if (list[i].id==info.company_id){
              this.company_name=list[i].company_name;
              break;
            }
          }
        }
      })
    },
    getBaseInfo(){
      this.$post('/api/index/dict',{}).then(res => {
        this.setProviderList(res.data)
      });
    },
    getIndexInfo(){
      this.$post('/api/user/fail_info', {}).then(res => {
          this.infos=res.data;
        this.getBaseInfo()
        //this.getProvince()
        this.getCompanyList(res.data)
      })
    },
    setProviderList(data){
      if(data.identify_type){
        let info=data.identify_type;
        this.identify_name=info[this.infos.identify_type]
      }
      if(data.provider_type){
        let info=data.provider_type;
        this.provider_name=info[this.infos.provider_type]
      }

    },
    handleImageSuccess(response) {
      let data = response.data
      this.info.avatar = data.url
      this.path = data.path
    },
    handleError(){
      this.$message.error('上传失败')

    },
    handleRemove(file) {
      let  imgPath = file.response.data.url;
      let list=this.imgs;
      for (let i=0,len=list.length;i<len;i++){
        if (list[i]==imgPath){
          list.splice(i,1);
          break
        }
      }
      this.imgs = list
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    sub(){
      let info=this.info;
      if (!info.nickname){
        return this.$message.error('请填写昵称')
      }
      this.disable=true
      this.$put('/api/user',{nickname:info.nickname,avatar:this.path}).then((res)=>{
        this.$message.success(res.msg)
        this.getUserInfo()
        this.disable=false
      }).catch(()=>{
        this.disable=false
      })
    }
  }
}
</script>

<style  lang="scss">
   .user-info{
     .edit-content{
       padding: 0 31px 52px;
       .upload-item{
          .avatar{
            width: 126px;
            height: 126px;
            border: 1px dashed #ddd;
            border-radius: 10px;
            margin-right: 18px;
            img{
              width: 126px;
              height: 126px;
              border-radius: 10px;
              object-fit: cover;
            }
          }
           .up-text{
               background: #FFCCCC;
               border-radius: 32px;
               font-size: 14px;
               font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
               font-weight: 500;
               color: #F42323;
               padding:5px 14px;
           }
       }
       .input-content{
         margin-top: 40px;
         .input-item{
           margin-bottom: 11px;
           .label{
             width: 150px;
             text-align: right
           }
           .input{
             min-width: 343px;
             height: 40px;
             line-height: 40px;
             padding: 0 17px;
             //border-radius: 5px;
             //border: 1px solid #E4E4E4;
             font-size: 14px;
             img{

             }
           }
         .imgInput{
           height: auto;
           img{
             width: 164px;
             height: 97px;
             object-fit: contain
           }
         }
         }
         .title{
           font-weight: 500;
           font-size: 18px;
           color: #333333;
           line-height: 20px;
           margin: 30px 0 22px 0;
           padding-left: 10px;
         }
         .photo-tip{
           font-weight: 400;
           font-size: 12px;
           color: #9E9E9E;
           line-height: 24px;
           padding-left: 10px;
           .t-title{

             color: #333;

           }
           .t-sub{
             color: #9e9e9e;
             span{
               color: #FF3131;
             }
           }
         }
         .img-content{
           .imgs{
             .sfz-content{
               img{
                 width: 208px;
                 height: 126px;
               }
             }
           }
           .sub-btn{
             div{
               width: 345px;
               line-height: 50px;
               text-align: center;
               color: #fff;
               background: linear-gradient( 270deg, #1988FF 0%, #1565F7 100%);
               border-radius: 50px 50px 50px 50px;
             }
           }
         }
       }
       .main-button{
           max-width:345px;
           line-height: 50px;
       }
     }
   }
</style>
